import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/Results/ResultsHeader.js";
const variants = import.meta.webpackContext("/components/Results", { recursive: true, regExp: /\.\/__variants__\/plp\-(?:mweb\-image\-gallery\/v3|promo\-label\/shown)\/ResultsHeader\.js/ });
export default pointCut({ joinPoint, variants });